import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { isTestingEnv } from '../test-utils/is-testing-env';
import type { BcfRouterServerSession } from './bcf-router-server-session';
import { provideBcfRouterServerSession } from './bcf-router-server-session';
import { extractBaseHrefFromCsr } from './pure-utils/extract-base-href-from-csr';

export class BcfRouterBaseHref {
  constructor(private _bcfRouterServerSession: BcfRouterServerSession = provideBcfRouterServerSession()) {}

  // "/" "/casino/" "/sports/"
  public get baseHref(): string {
    if (__RENDER_MODE__ === 'server') {
      return this._bcfRouterServerSession.ssrBaseHref;
    }
    if (isTestingEnv) {
      return '/';
    }
    return extractBaseHrefFromCsr();
  }
}
export function provideBcfRouterBaseHref(): BcfRouterBaseHref {
  return provideSingleton(BcfRouterBaseHref, () => new BcfRouterBaseHref());
}
